import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'istDate',
	standalone: true
})

export class IstDatePipe implements PipeTransform {
	transform(utcDateString: string): string {
		if (!utcDateString) return '';
		const date = new Date(utcDateString + 'Z');
		return new Intl.DateTimeFormat('en-IN', {
			timeZone: 'Asia/Kolkata',
			dateStyle: 'medium',
			timeStyle: 'short'
		}).format(date);
	}
}